// A milestone's bar color identifies the milestone itself (order-based, not
// status-based) so a busy Gantt stays scannable — status is communicated
// separately through the status pill/dot. Colors are muted, not neon, to fit
// the app's professional/construction tone.
const MILESTONE_COLOR_PALETTE = [
  "#4CAF50", // green
  "#3B82F6", // blue
  "#8B5CF6", // purple
  "#F59E0B", // orange
  "#14B8A6", // teal
  "#EC4899", // pink
  "#A78BFA", // lavender
  "#64748B" // slate
] as const

// Deterministic by position, not id — cycles through the same 8 colors, so a
// project with more milestones than colors repeats the sequence rather than
// hashing into something unstable.
const getMilestoneColor = (index: number): string =>
  MILESTONE_COLOR_PALETTE[index % MILESTONE_COLOR_PALETTE.length]

export { MILESTONE_COLOR_PALETTE, getMilestoneColor }
